import React from 'react';
import PropTypes from 'prop-types';

import { FontSizes, FontWeights } from '../Theme';

const Checkbox = ({ checked, disabled, label, onChange }) => {
  const styles = {
    component: {
      padding: '4px 0',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    checkbox: {
      fontSize: 20
    },
    label: {
      fontSize: FontSizes.REGULAR,
      fontWeight: FontWeights.REGULAR,
      lineHeight: '1.3em',
      width: '100%',
      marginLeft: 10,
      textTransform: 'none',
      letterSpacing: 0
    }
  };

  return (
    <label onChange={onChange} style={styles.component}>
      <input
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        style={styles.checkbox}
        type='checkbox'
      />
      <span style={styles.label}>{label}</span>
    </label>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func
};

export default Checkbox;
